import './Loading.scss';

const Loading = () => {
  return (
    <div className="Loading">
      <h3 className="Loading__text">Loading...</h3>
    </div>
  )
}

export default Loading;